var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * InterfaceFolderBlock component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconInterfaceFolderBlock extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.71152 2.76999C9.564 2.65789 9.38253 2.59969 9.19733 2.60508C9.19005 2.60529 9.18277 2.6054 9.17549 2.6054H3.41624C3.20121 2.6054 2.99499 2.69082 2.84294 2.84287M9.71153 2.77C9.8574 2.88087 9.96137 3.03783 10.0066 3.21524L10.4417 5.14214C10.5189 5.4841 10.8227 5.72695 11.1733 5.72695H20.5379C20.753 5.72695 20.9592 5.81239 21.1111 5.96436C21.2632 6.11649 21.3487 6.32276 21.3487 6.53772V9.26907C21.3487 9.68328 21.6845 10.0191 22.0987 10.0191C22.5129 10.0191 22.8487 9.68328 22.8487 9.26907V6.53772C22.8487 5.92478 22.6051 5.33709 22.1719 4.90381C21.7386 4.47036 21.1507 4.22695 20.5379 4.22695H11.7728L11.4678 2.8764L11.4644 2.86191C11.3379 2.3492 11.0396 1.8953 10.6192 1.57577L10.6192 1.57576C10.2019 1.25864 9.68932 1.09286 9.16563 1.1054H3.41624C2.80338 1.1054 2.21563 1.34886 1.78228 1.78221L1.78228 1.78221C1.34892 2.21556 1.10547 2.80332 1.10547 3.41618V18.2434C1.10547 18.8564 1.34887 19.444 1.78219 19.8773C2.21565 20.3109 2.80347 20.5542 3.41624 20.5542H8.48875C8.90296 20.5542 9.23875 20.2184 9.23875 19.8042C9.23875 19.39 8.90296 19.0542 8.48875 19.0542H3.41624C3.20111 19.0542 2.99497 18.9688 2.84303 18.8168L2.84289 18.8167C2.69089 18.6647 2.60547 18.4586 2.60547 18.2434V3.41618C2.60547 3.20114 2.69089 2.99492 2.84294 2.84287"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.0725 12.7507C14.6852 12.7507 12.75 14.686 12.75 17.0732C12.75 19.4605 14.6853 21.3957 17.0725 21.3957C19.4597 21.3957 21.395 19.4605 21.395 17.0732C21.395 14.686 19.4597 12.7507 17.0725 12.7507ZM11.25 17.0732C11.25 13.8576 13.8568 11.2507 17.0725 11.2507C20.2881 11.2507 22.895 13.8575 22.895 17.0732C22.895 20.2889 20.2882 22.8957 17.0725 22.8957C13.8568 22.8957 11.25 20.2889 11.25 17.0732Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9531 12.9529C13.246 12.6601 13.7208 12.6601 14.0137 12.9529L21.1933 20.1326C21.4862 20.4255 21.4862 20.9003 21.1933 21.1932C20.9004 21.4861 20.4256 21.4861 20.1327 21.1932L12.9531 14.0136C12.6602 13.7207 12.6602 13.2458 12.9531 12.9529Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderBlock.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderBlock.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceFolderBlock.prototype, "size", void 0);
if (customElements.get('cat-icon-interface-folder-block') === undefined) {
    customElements.define('cat-icon-interface-folder-block', BlocksIconInterfaceFolderBlock);
}
